import $ from 'jquery';

function getCellFromPoint(x, y) {
  // scrollTop takes into account a scrolled page
  const $cell = $(document.elementFromPoint(x, y - $(document).scrollTop())).closest('td');
  if ($cell.length > 0) {
    return $cell;
  }

  // td cell may not be found using elementFromPoint, use elementsFromPoint
  // to find all elements and filter by tag name
  if (document.elementsFromPoint) {
    const elements = document
      .elementsFromPoint(x, y - $(document).scrollTop())
      .filter(node => node.tagName.toUpperCase() === 'TD');

    return elements.length > 0 ? $(elements[0]) : $();
  } else if (document.msElementsFromPoint) {
    const nodeList = document.msElementsFromPoint(x, y - $(document).scrollTop());
    if (nodeList) {
      let $tdCell = $();

      Array.prototype.forEach.call(nodeList, (node) => {
        if (node.tagName.toUpperCase() === 'TD') {
          $tdCell = $(node);
        }
      });
      return $tdCell;
    }
  }

  return $();
}

/**
* get popup editor positoin,
*  based on cellPosition & editor width & related position option setting
*
* @param {Object} cellPosition - position where popup editor event was triggered
* @param {Object} $editor - editorView that will be host inside popup editor
* @param {boolean} isRTL - whether culture is RTL, default false
* @param {boolean} renderBelow - whether to render poup editor below cellPosition,
* @param {boolean} parentContainerSelector - custom selector for parent container
  default false
* @param {boolean} adjustTopPosition - whether to adjust top position,
  default true
* @returns {void} void
*/
export function getPosition(
  cellPosition,
  $editor,
  isRTL,
  renderBelow,
  parentContainerSelector = null,
  adjustTopPosition = true
) {
  const cTop = cellPosition.top;
  const cLeft = cellPosition.left;
  const $cell = getCellFromPoint(cLeft, cTop);
  let left;
  let top = cTop;

  if (isRTL) {
    left = cLeft - $editor.width() + $cell.width() - 20; // eslint-disable-line no-mixed-operators
  } else {
    left = cLeft - 10;

    // eslint-disable-next-line no-mixed-operators
    let widthDiff = cLeft + $editor.outerWidth();

    if (parentContainerSelector) {
      const parentLeft = $(parentContainerSelector).offset() ?
        $(parentContainerSelector).offset().left : 0;
      widthDiff += parentLeft;
      const $table = $(`${parentContainerSelector} .table, ${parentContainerSelector} table`);
      const tableLeft = $table.offset() ? $table.offset().left : 0;
      widthDiff -= tableLeft + $table.width();
    } else {
      widthDiff -= document.body.clientWidth;
    }

    // adjust right edge if it extend past the grid's viewport
    if (widthDiff > 0) {
      left -= widthDiff;
    }
  }

  if (!adjustTopPosition) {
    return { top, left };
  }
  if (renderBelow) {
    if ($cell.length > 0) {
      // render below the content (assumes equal top/bottom padding)
      const height = $cell.children().length > 0 ? $cell.children().height() : $cell.height();
      const padding = ($cell.outerHeight() - height) / 2;

      // add offset of 5
      top += $cell.outerHeight() - padding + 2; // eslint-disable-line no-mixed-operators
    }
  } else {
    top -= 10;
  }

  return {
    top,
    left,
  };
}

export function getEditorPositionAsideAnchor($anchor) {
  const space = 5;

  function getEditorPosition($editor) {
    const {
      top: anchorTop,
      left: anchorLeft,
    } = $anchor.offset();
    const anchorWidth = $anchor.outerWidth();
    const editorWidth = $editor.outerWidth();

    const editorTop = anchorTop - 10;

    // place at right side
    let editorLeft = anchorLeft + anchorWidth + space;

    if ((editorLeft + editorWidth) > document.body.clientWidth) {
      // place at left side
      editorLeft = anchorLeft - editorWidth - space;
    }

    return {
      top: editorTop,
      left: editorLeft,
    };
  }

  return getEditorPosition;
}
